<template>
  <div class="mainbody">
    <div v-cloak>
      <div class="location">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item> 管理中心 </el-breadcrumb-item>
          <el-breadcrumb-item>订单管理</el-breadcrumb-item>
          <el-breadcrumb-item>查看订单</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="content-box">
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane label="基本信息" name="info">
            <div class="tab-content">
              <el-row class="card-form">
                <el-col :xs="24" :sm="12">
                  <el-card shadow="hover">
                    <div slot="header" class="clearfix">
                      <span>订单信息</span>
                    </div>
                    <div class="dl-box">
                      <dl>
                        <dt>客户名称</dt>
                        <dd>
                          <b>{{ model.companyFullName }}</b>
                        </dd>
                      </dl>

                      <dl>
                        <dt>设备编号</dt>
                        <dd>{{ model.cabinetCode }}</dd>
                      </dl>
                      <dl>
                        <dt>设备标签</dt>
                        <dd>{{ model.cabinetName }}</dd>
                      </dl>
                      <dl>
                        <dt>状态</dt>
                        <dd>
                          <span v-if="model.chargeType == 1">充电</span>
                          <span v-else-if="model.chargeType == 2">放电</span>
                          <span v-else>空闲</span>
                        </dd>
                      </dl>

                      <dl>
                        <dt>开始时间</dt>
                        <dd>
                          {{ model.startTime }}
                        </dd>
                      </dl>

                      <dl>
                        <dt>结束时间</dt>
                        <dd>
                          {{ model.endTime }}
                        </dd>
                      </dl>

                      <dl>
                        <dt>上报时间</dt>
                        <dd>{{ model.gmtCreate }}</dd>
                      </dl>
                    </div>
                  </el-card>
                </el-col>
                <el-col :xs="24" :sm="12">
                  <el-card shadow="hover">
                    <div slot="header" class="clearfix">
                      <span>电量/收益</span>
                    </div>
                    <div class="dl-box">
                      <dl>
                        <dt>时段</dt>
                        <dd>
                          <span v-if="model.periodType == 1"> 尖 </span>
                          <span v-else-if="model.periodType == 2"> 峰 </span>
                          <span v-else-if="model.periodType == 3"> 平 </span>
                          <span v-else-if="model.periodType == 4"> 谷 </span>
                          <span v-else> 高尖 </span>
                        </dd>
                      </dl>

                      <dl>
                        <dt>充电量(度)</dt>
                        <dd>{{ model.chargePower }}</dd>
                      </dl>
                      <dl>
                        <dt>放电量(度)</dt>
                        <dd>{{ model.dischargePower }}</dd>
                      </dl>

                      <dl>
                        <dt>收益(元)</dt>
                        <dd>{{ model.profit }} 元</dd>
                      </dl>
                    </div>

                    <div class="dl-box" v-show="false">
                      <dl>
                        <dt>尖时电量</dt>
                        <dd>{{ model.topPower }} 度</dd>
                      </dl>
                      <dl>
                        <dt>尖时费用</dt>
                        <dd>{{ model.topFee }} 元</dd>
                      </dl>

                      <dl>
                        <dt>峰时电量</dt>
                        <dd>{{ model.peakPower }} 度</dd>
                      </dl>
                      <dl>
                        <dt>峰时费用</dt>
                        <dd>{{ model.peakFee }} 元</dd>
                      </dl>

                      <dl>
                        <dt>平时电量</dt>
                        <dd>{{ model.flatPower }} 度</dd>
                      </dl>
                      <dl>
                        <dt>平时费用</dt>
                        <dd>{{ model.flatFee }} 元</dd>
                      </dl>

                      <dl>
                        <dt>谷时电量</dt>
                        <dd>{{ model.valleyPower }} 度</dd>
                      </dl>
                      <dl>
                        <dt>谷时费用</dt>
                        <dd>{{ model.valleyFee }} 元</dd>
                      </dl>

                      <dl>
                        <dt>总电量</dt>
                        <dd>{{ model.totalPower }} 元</dd>
                      </dl>
                      <dl>
                        <dt>总费用</dt>
                        <dd>{{ model.totalFee }} 元</dd>
                      </dl>

                      <dl v-show="false">
                        <dt>开始Soc</dt>
                        <dd>{{ model.startSoc }} %</dd>
                      </dl>
                      <dl v-show="false">
                        <dt>结束Soc</dt>
                        <dd>{{ model.endSoc }} %</dd>
                      </dl>
                    </div>
                  </el-card>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>

      <div class="footer-box">
        <div class="footer-btn">
          <el-button plain @click="back">返回上一页</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { AxiosAjax } from "../../js/axios.config";
export default {
  data() {
    return {
      activeName: "info", //当前选项卡
      labelPosition: "right", //表单对齐方式

      model: {
        gmtCreate: "2022-02-22 15:14:52",
        createdBy: "system",
        modifiedBy: "system",
        gmtModified: "2022-02-22 15:14:59",
        id: "0",
        type: 0,
        chargeType: "",
        companyId: "0",
        cabinetId: "",
        billId: null,
        startTime: "2022-02-22 10:14:07",
        startSysTime: "2022-02-22 10:14:07",
        endTime: "2022-02-22 15:14:14",
        endSysTime: "2022-02-22 15:14:14",
        startSoc: 0,
        endSoc: 0,
        totalPower: 0,
        totalFee: 0,
        topPower: 0,
        topFee: 0,
        peakPower: 0,
        peakFee: 0,
        flatPower: 0,
        flatFee: 0,
        valleyPower: 0,
        valleyFee: 0,
        companyName: "",
        companyFullName: "",
        cabinetCode: "",
        cabinetName: "",
        chargePower: "",
        dischargePower: "",
        profit: "",
        periodType: "",
      },
    };
  },
  mounted() {},
  methods: {
    //初始化数据
    initData: function () {
      let _parent = this; //父页面
      let _this = this; //当前页面
      //判断是否有父窗体
      if (typeof parent.vm != "undefined") {
        _parent = parent.vm;
      }
      let id = _this.$route.query.id || ""; //获取ID
      if (!id) {
        _parent.$alert("参数有误，找不到订单信息。", "错误提示", {
          confirmButtonText: "确定",
          callback: (action) => {
            _this.back();
          },
        });
      } else {
        AxiosAjax({
          url: "/cabinet/order/" + id,
          loading: true,
          success: function (res) {
            //赋值给model
            Object.keys(_this.model).forEach((key) => {
              _this.model[key] = res.data.data[key];
            });
          },
        });
      }
    },
    //加载图片地址
    loadImage: function (src) {
      return baseApi + src;
    },
    //跳转链接
    linkUrl: function (url) {
      window.location.href = url;
    },
    //返回上一页
    back() {
      window.history.back(-1);
    },
  },
  created: function () {
    //初始化数据
    this.initData();
  },
};
</script>
<style scoped>
.content-box .card-form .dl-box dl dt {
  font-weight: bold;
  color: #000000;
  width: 25%;
}
</style>



// WEBPACK FOOTER //
// src/components/Order/OrderShow.vue